import { Button } from "@radix-ui/themes";
import { useNavigate } from "react-router-dom";

export const SubmitSuccessScreen = ({ message = 'Thank You For Completing the survey'}:{ message?:string }) => {
  const router = useNavigate();

  return (
    <div className="flex flex-col gap-5 px-[1.5%]">
      <p>{message}</p>
      <Button
        color="purple"
        variant="solid"
        size="3"
        className="w-20"
        onClick={() => router(-1)}
      >
        Ok
      </Button>
    </div>
  );
};
